module.exports = __webpack_public_path__ + "img/fo-groups-logo.267c4fee.png";